import api from './api';

export const getBusinessReportingObligations = (businessId, params = {}) =>
  api.get(`/businesses/${businessId}/reporting-obligations`, { params });

export const createReportingObligation = (businessId, data) =>
  api.post(`/businesses/${businessId}/reporting-obligations`, data);

export const updateReportingObligationStatus = (obligationId, data) =>
  api.patch(`/reporting-obligations/${obligationId}/status`, data);
